import React from "react";
import styles from "./PrivacyPolicy.module.css";
import { ContactData } from "../../controller/ContactData";

const PrivacyPolicy = () => {
  // Separate email and address from ContactData
  const email = ContactData.find((item) => item.id === 1)?.text;
  const phone = ContactData.find((item) => item.id === 2)?.text;
  const address = ContactData.find((item) => item.id === 3)?.text;
  const effectiveDate = "13/02/2026";

  const sections = [
    {
      title: "1. Information We Collect",
      content: [
        "We collect information to provide better services and improve your experience. This includes personal information such as your name, email address, phone number, account details, payment information, and any professional details you share. We also collect non-personal information, including your IP address, device type, browser, pages you visit, and interaction patterns. In some cases, you may provide sensitive information when necessary for regulatory or service purposes.",
        "We collect this information:",
      ],
      list: [
        "Directly from you when you fill forms, register, subscribe, or contact us.",
        "Automatically through cookies, analytics tools, and server logs.",
        "From trusted third parties such as business partners or service providers.",
      ],
    },
    {
      title: "2. How We Use Your Information",
      content: ["We use the information we collect to:"],
      list: [
        "Deliver and maintain our Services, including software updates and support.",
        "Personalize your experience on our Website and Services. ",
        "Communicate with you about updates, support, and promotional offers (if you have opted in). ",
        "Analyze trends and improve our Website, Services, and features.",
        "Comply with legal obligations and protect the rights and safety of our Company and users. ",
      ],
    },
    {
      title: "3. Sharing and Disclosure of Information",
      content: [
        "We do not sell your personal information to third parties. However, we may share information ",
        "with:",
      ],
      list: [
        "Service providers who help us deliver Services, including hosting, analytics, payment processing, and customer support.",
        "Legal authorities when required by law, regulation, or court order.",
        "Business transfers such as mergers or acquisitions, ensuring that your information continues to be protected.",
      ],
    },
    {
      title: "4. Cookies and Tracking ",
      content: [
        "We use cookies and similar technologies to improve your experience on our website. Cookies help us remember your preferences, analyze Website performance, and provide personalized content. You can disable cookies in your browser settings, but this may affect certain functionalities. ",
      ],
    },
    {
      title: "5. Data Security",
      content: [
        "We implement reasonable measures to protect your data, including encryption, secure servers, and access controls. While we work hard to safeguard your information, no system can guarantee complete security, and we cannot ensure absolute protection.",
      ],
    },
    {
      title: "6. Data Retention ",
      content: [
        "We retain your personal information only as long as necessary to provide our Services, comply with legal obligations, resolve disputes, or enforce agreements. When data is no longer needed, we securely delete or anonymize it",
      ],
    },
    {
      title: "7. Your Privacy Rights ",
      content: ["Depending on your location, you may have rights to:"],
      list: [
        "Access or correct your personal information.",
        "Request deletion of your data.",
        "Withdraw consent or opt out of marketing communications.",
        "To exercise these rights, contact us at info@bharatclouds.com.",

      ],
    },
    {
      title: "8. Third-Party Services and Links",
      content: [
        "Our website may include links to third-party websites or services. We are not responsible for their privacy practices, content, or security. Please review their privacy policies before sharing any personal information.",
      ],
    },
     {
      title: "9. International Data Transfers ",
      content: [
        "If you access our website from outside India, your information may be transferred to countries with different data protection laws. We ensure such transfers comply with applicable regulations and continue to protect your data.",
      ],
    },
     {
      title: "10. Children’s Privacy",
      content: [
        "This website isn’t meant for use by children. We don’t collect their personal information. If we find any, we’ll delete it right away.",
        "This applies only to the website not to Bharat Clouds Private Limited’s products or services, which follow separate policies.",
      ],
    },
     {
      title: "11. Changes to This Privacy Policy",
      content: [
        "We may update this Privacy Policy to reflect changes in our practices, Services, or legal requirements. Updates will be posted here with a revised Effective Date. Continued use of our website or Services after changes constitutes acceptance of the updated policy.",
      ],
    },
      {
      title: "12. Contact Information",
      content: [
        "If you have questions, concerns, or requests regarding this Privacy Policy, please contact us:",
      ],
    },
  ];

  return (
    <div className={styles.privacyContainer}>
      {/* Breadcrumb */}
      {/* <div className={styles.terms}>
        <ul className="list-unstyled d-flex gap-1 m-0 align-items-center">
          <li>
            <a href="#" className={styles.link}>
              Terms of Use
            </a>
          </li>
          <li>/</li>
          <li>
            <a href="#" className={styles.linkActive}>
              Privacy Policy
            </a>
          </li>
        </ul>
      </div> */}

      {/* Main Heading */}
      <div className={styles.headingContainer}>
        <h5 className={`${styles.mainHeading}`}>Privacy Policy</h5>
      </div>
      <p className={styles.effectiveDate}>
        <strong>Effective Date:</strong> {effectiveDate}
      </p>
      <div className={styles.titleWrapper}>
        <h5 className={`${styles.titleHeading}`}>
          At Bharat Clouds Private Limited, your privacy is important to us.
          This Privacy Policy explains how we collect, use, share, and protect
          the information you provide when you visit our website,
          https://bharatclouds.com (“Website”), or use our software,
          applications, or other services (collectively, “Services”). By using
          our website or services, you agree to this Privacy Policy.
        </h5>
      </div>

      {/* Sections */}
      {sections.map((section, index) => (
        <div key={index} className={styles.policySection}>
          <h5>{section.title}</h5>

          {section.content.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
      <div className={styles.contactSection}>
        <h5 className={styles.policySectionh5}>Email:</h5>
        <p className={styles.policySectionP}>{email}</p>

        <h5 className={styles.policySectionh5}>Phone:</h5>
        <p className={styles.policySectionP}>{phone}</p>

        <h5 className={styles.policySectionh5}>Address:</h5>
        <p className={styles.policySectionP}>{address}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
